/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MasterZoneRestService, OfficeRestService, OfficeStatus, OfficeType } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { Observable } from 'rxjs';
import { BuilderUserContext } from '../../user';
import { MasterZone } from './master-zone.model';
import { Office } from './office.model';

@Injectable()
export class SwitchToBusinessService implements InitViewService {

  constructor(private userContext: BuilderUserContext,
              private dictionaryService: DictionaryService,
              private masterZoneRest: MasterZoneRestService,
              private officeRest: OfficeRestService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      officeStatus: this.dictionaryService.getByEnum(OfficeStatus),
      officeType: this.dictionaryService.getByEnum(OfficeType),
      masterZones: this.userContext.corporateView ? this.findAllMasterZones() : [this.userContext.masterZone],
    };
  }

  findAllMasterZones(): Observable<MasterZone[]> {
    return this.masterZoneRest.findAll();
  }

  findAllOfficesByMaster(masterId: ID): Observable<Office[]> {
    return this.officeRest.findAllByMasterZone(masterId, ['NEW', 'ACTIVE', 'BLOCKED'], ['FRANCHISE', 'TEMPLATE', 'TRAINING']);
  }
}
